import { render, staticRenderFns } from "./appendButton-editor.vue?vue&type=template&id=3afb70e8&scoped=true&"
import script from "./appendButton-editor.vue?vue&type=script&lang=js&"
export * from "./appendButton-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb70e8",
  null
  
)

export default component.exports